/*
  Translations for workspace copy added after the main dictionaries
  (LetsCampaign sign-in screen, theme switch, plan locks, plan catalog).
  Merged into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  'Cannot reach the server. Check your connection and try again.': 'Сервер недоступен. Проверьте подключение и попробуйте ещё раз.',
  'Clicks are never counted': 'Клики не тарифицируются',
  'However much traffic you send, the invoice does not move.': 'Сколько бы трафика вы ни отправили, счёт не изменится.',
  'Bots filtered on arrival': 'Боты отсекаются на входе',
  'Datacenter, VPN and proxy traffic is handled before a page loads.': 'Трафик дата-центров, VPN и прокси обрабатывается ещё до загрузки страницы.',
  'First link in five minutes': 'Первая ссылка за пять минут',
  'Add a source, create a campaign, copy the link.': 'Добавьте источник, создайте кампанию, скопируйте ссылку.',
  'Your workspace': 'Ваш кабинет',
  'Everything is already running': 'Всё уже работает',
  'Your workspace, your campaigns, your numbers.': 'Ваш кабинет, ваши кампании, ваши цифры.',
  'Confirm your email': 'Подтвердите почту',
  'Open the link we sent and your workspace is ready.': 'Откройте ссылку из письма — и кабинет готов.',
  'Enter your code': 'Введите код',
  'Six digits from your authenticator app.': 'Шесть цифр из приложения-аутентификатора.',
  'Create your account': 'Создайте аккаунт',
  'Two fields and a password. Tracking is live in minutes.': 'Два поля и пароль. Трекинг заработает через несколько минут.',
  'We sent a confirmation link to': 'Мы отправили ссылку для подтверждения на',
  'Check spam if it is not there within a minute. The link lasts 24 hours.': 'Если письма нет через минуту, проверьте «Спам». Ссылка действует 24 часа.',
  'Sent again. Give it a moment.': 'Отправили ещё раз. Подождите немного.',
  'Sending': 'Отправляем',
  'Use a different account': 'Войти в другой аккаунт',
  'Verification code': 'Код подтверждения',
  'Checking': 'Проверяем',
  'Signing in': 'Входим',
  'Your name': 'Ваше имя',
  'At least 8 characters.': 'Не меньше 8 символов.',
  'Creating': 'Создаём',
  'Continue with': 'Продолжить через',
  'No account yet?': 'Ещё нет аккаунта?',
  'Create one': 'Создать',
  'New accounts are closed at the moment.': 'Регистрация новых аккаунтов сейчас закрыта.',
  'Terms': 'Условия',
  'and': 'и',
  'Privacy': 'Конфиденциальность',
  'History kept forever': 'История хранится бессрочно',
  'Light theme': 'Светлая тема',
  'Dark theme': 'Тёмная тема',
  'Match system': 'Как в системе',
  'Theme': 'Тема',
  'Navigate': 'Навигация',
  'Not included on your plan. Open Billing to upgrade.': 'Не входит в ваш тариф. Откройте «Оплату», чтобы перейти на другой.',
  'Talk to us': 'Связаться с нами',
  'Workspace': 'Кабинет',
  'Automatic flow optimiser': 'Автоматический оптимизатор потоков',
  'Learning bot detection': 'Самообучающееся обнаружение ботов',
  'Lead forms into a CRM': 'Лид-формы в CRM',
  'Roles and 31 permissions': 'Роли и 31 право доступа',
  'Single sign on': 'Единый вход (SSO)',
  'We move you off your old tracker': 'Перенесём вас со старого трекера',
  '90 days of history': '90 дней истории',
  '1 year of history': '1 год истории',
  '2 years of history': '2 года истории',
  'History kept': 'История хранится',
  'Your first campaigns, with nothing to set up.': 'Первые кампании — без всякой настройки.',
  'Everything that makes the work run itself.': 'Всё, чтобы работа шла сама.',
  'A team, with roles and a paper trail.': 'Команда — с ролями и журналом действий.',
  'A network, under your own brand.': 'Сеть — под вашим собственным брендом.',
};

const es = {
  'Cannot reach the server. Check your connection and try again.': 'No se puede conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.',
  'Clicks are never counted': 'Los clics nunca se cobran',
  'However much traffic you send, the invoice does not move.': 'Envíes el tráfico que envíes, la factura no cambia.',
  'Bots filtered on arrival': 'Bots filtrados al llegar',
  'Datacenter, VPN and proxy traffic is handled before a page loads.': 'El tráfico de centros de datos, VPN y proxies se gestiona antes de que cargue la página.',
  'First link in five minutes': 'Primer enlace en cinco minutos',
  'Add a source, create a campaign, copy the link.': 'Añade una fuente, crea una campaña, copia el enlace.',
  'Your workspace': 'Tu espacio de trabajo',
  'Everything is already running': 'Todo ya está funcionando',
  'Your workspace, your campaigns, your numbers.': 'Tu espacio, tus campañas, tus números.',
  'Confirm your email': 'Confirma tu correo',
  'Open the link we sent and your workspace is ready.': 'Abre el enlace que te enviamos y tu espacio estará listo.',
  'Enter your code': 'Introduce tu código',
  'Six digits from your authenticator app.': 'Seis dígitos de tu app de autenticación.',
  'Create your account': 'Crea tu cuenta',
  'Two fields and a password. Tracking is live in minutes.': 'Dos campos y una contraseña. El tracking funciona en minutos.',
  'We sent a confirmation link to': 'Enviamos un enlace de confirmación a',
  'Check spam if it is not there within a minute. The link lasts 24 hours.': 'Si no llega en un minuto, revisa el spam. El enlace dura 24 horas.',
  'Sent again. Give it a moment.': 'Enviado de nuevo. Espera un momento.',
  'Sending': 'Enviando',
  'Use a different account': 'Usar otra cuenta',
  'Verification code': 'Código de verificación',
  'Checking': 'Comprobando',
  'Signing in': 'Entrando',
  'Your name': 'Tu nombre',
  'At least 8 characters.': 'Al menos 8 caracteres.',
  'Creating': 'Creando',
  'Continue with': 'Continuar con',
  'No account yet?': '¿Aún no tienes cuenta?',
  'Create one': 'Crear una',
  'New accounts are closed at the moment.': 'Por ahora no se admiten cuentas nuevas.',
  'Terms': 'Términos',
  'and': 'y',
  'Privacy': 'Privacidad',
  'History kept forever': 'Historial para siempre',
  'Light theme': 'Tema claro',
  'Dark theme': 'Tema oscuro',
  'Match system': 'Según el sistema',
  'Theme': 'Tema',
  'Navigate': 'Navegación',
  'Not included on your plan. Open Billing to upgrade.': 'No incluido en tu plan. Abre Facturación para mejorarlo.',
  'Talk to us': 'Hablar con nosotros',
  'Workspace': 'Espacio de trabajo',
  'Automatic flow optimiser': 'Optimizador automático de flujos',
  'Learning bot detection': 'Detección de bots con aprendizaje',
  'Lead forms into a CRM': 'Formularios de leads a un CRM',
  'Roles and 31 permissions': 'Roles y 31 permisos',
  'Single sign on': 'Inicio de sesión único (SSO)',
  'We move you off your old tracker': 'Te migramos desde tu tracker anterior',
  '90 days of history': '90 días de historial',
  '1 year of history': '1 año de historial',
  '2 years of history': '2 años de historial',
  'History kept': 'Historial guardado',
  'Your first campaigns, with nothing to set up.': 'Tus primeras campañas, sin nada que configurar.',
  'Everything that makes the work run itself.': 'Todo lo que hace que el trabajo funcione solo.',
  'A team, with roles and a paper trail.': 'Un equipo, con roles y registro de cambios.',
  'A network, under your own brand.': 'Una red, con tu propia marca.',
};

const pt = {
  'Cannot reach the server. Check your connection and try again.': 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.',
  'Clicks are never counted': 'Cliques nunca são cobrados',
  'However much traffic you send, the invoice does not move.': 'Não importa quanto tráfego você envie, a fatura não muda.',
  'Bots filtered on arrival': 'Bots filtrados na chegada',
  'Datacenter, VPN and proxy traffic is handled before a page loads.': 'Tráfego de datacenter, VPN e proxy é tratado antes de a página carregar.',
  'First link in five minutes': 'Primeiro link em cinco minutos',
  'Add a source, create a campaign, copy the link.': 'Adicione uma fonte, crie uma campanha, copie o link.',
  'Your workspace': 'Seu espaço de trabalho',
  'Everything is already running': 'Tudo já está funcionando',
  'Your workspace, your campaigns, your numbers.': 'Seu espaço, suas campanhas, seus números.',
  'Confirm your email': 'Confirme seu e-mail',
  'Open the link we sent and your workspace is ready.': 'Abra o link que enviamos e seu espaço estará pronto.',
  'Enter your code': 'Digite seu código',
  'Six digits from your authenticator app.': 'Seis dígitos do seu app autenticador.',
  'Create your account': 'Crie sua conta',
  'Two fields and a password. Tracking is live in minutes.': 'Dois campos e uma senha. O tracking funciona em minutos.',
  'We sent a confirmation link to': 'Enviamos um link de confirmação para',
  'Check spam if it is not there within a minute. The link lasts 24 hours.': 'Se não chegar em um minuto, verifique o spam. O link vale por 24 horas.',
  'Sent again. Give it a moment.': 'Enviado novamente. Aguarde um momento.',
  'Sending': 'Enviando',
  'Use a different account': 'Usar outra conta',
  'Verification code': 'Código de verificação',
  'Checking': 'Verificando',
  'Signing in': 'Entrando',
  'Your name': 'Seu nome',
  'At least 8 characters.': 'Pelo menos 8 caracteres.',
  'Creating': 'Criando',
  'Continue with': 'Continuar com',
  'No account yet?': 'Ainda não tem conta?',
  'Create one': 'Criar uma',
  'New accounts are closed at the moment.': 'No momento, não estamos aceitando novas contas.',
  'Terms': 'Termos',
  'and': 'e',
  'Privacy': 'Privacidade',
  'History kept forever': 'Histórico para sempre',
  'Light theme': 'Tema claro',
  'Dark theme': 'Tema escuro',
  'Match system': 'Igual ao sistema',
  'Theme': 'Tema',
  'Navigate': 'Navegação',
  'Not included on your plan. Open Billing to upgrade.': 'Não incluído no seu plano. Abra Cobrança para fazer upgrade.',
  'Talk to us': 'Fale conosco',
  'Workspace': 'Espaço de trabalho',
  'Automatic flow optimiser': 'Otimizador automático de fluxos',
  'Learning bot detection': 'Detecção de bots com aprendizado',
  'Lead forms into a CRM': 'Formulários de leads para um CRM',
  'Roles and 31 permissions': 'Funções e 31 permissões',
  'Single sign on': 'Login único (SSO)',
  'We move you off your old tracker': 'Migramos você do seu tracker antigo',
  '90 days of history': '90 dias de histórico',
  '1 year of history': '1 ano de histórico',
  '2 years of history': '2 anos de histórico',
  'History kept': 'Histórico mantido',
  'Your first campaigns, with nothing to set up.': 'Suas primeiras campanhas, sem nada para configurar.',
  'Everything that makes the work run itself.': 'Tudo o que faz o trabalho andar sozinho.',
  'A team, with roles and a paper trail.': 'Uma equipe, com funções e registro de alterações.',
  'A network, under your own brand.': 'Uma rede, com sua própria marca.',
};

const WORKSPACE_EXTRA = { ru, es, pt };
export default WORKSPACE_EXTRA;
